import React from "react";

import LoadingButton from "@mui/lab/LoadingButton";
import { Button, ButtonProps } from "@mui/material";

interface AuthButtonProps extends ButtonProps {
  loading?: boolean;
}

const AuthButton = ({
  children,
  loading,
  sx,
  ...buttonProps
}: AuthButtonProps) => {
  const ButtonComponent = loading == null ? Button : LoadingButton;

  return (
    <ButtonComponent
      variant="contained"
      color="primary"
      loading={loading}
      sx={{
        textTransform: "none",
        height: "48px",
        width: "100%",
        fontSize: "1rem",
        ...sx,
      }}
      {...buttonProps}
    >
      {children}
    </ButtonComponent>
  );
};

export default AuthButton;
